import { render, staticRenderFns } from "./ModalEventosCurrier.vue?vue&type=template&id=51e82ed2&scoped=true&"
import script from "./ModalEventosCurrier.vue?vue&type=script&lang=ts&"
export * from "./ModalEventosCurrier.vue?vue&type=script&lang=ts&"
import style0 from "./ModalEventosCurrier.vue?vue&type=style&index=0&id=51e82ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e82ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('51e82ed2', component.options)
    } else {
      api.reload('51e82ed2', component.options)
    }
    module.hot.accept("./ModalEventosCurrier.vue?vue&type=template&id=51e82ed2&scoped=true&", function () {
      api.rerender('51e82ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Despacho/ModalEventosCurrier.vue"
export default component.exports